import { render, staticRenderFns } from "./ConfigurationForm131.vue?vue&type=template&id=1f4e4658&scoped=true&lang=pug&"
import script from "./ConfigurationForm131.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationForm131.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationForm131.vue?vue&type=style&index=0&id=1f4e4658&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4e4658",
  null
  
)

export default component.exports